const NODE_ENV = process.env.NODE_ENV;
let API_BASE_URL = "https://city2city.kretosstechnology.com";
// let API_BASE_URL = "https://city2city-dev.kretosstechnology.com";
// let API_BASE_URL = "http://localhost:3010";

if (NODE_ENV === "development") {
  // API (Development)
  //   API_BASE_URL = "http://localhost:3010/api/v1/";
  API_BASE_URL = API_BASE_URL + "/api/v1/";
} else {
  // API (Production)
  API_BASE_URL = API_BASE_URL + "/api/v1/";
}

export default API_BASE_URL;
